import React from "react";
import { useParams } from "react-router-dom";

import { PageWithAppDrawer2 } from "../_components/main/PageWithAppDrawer2";

import { Paper, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import SignatureComponent from "../_components/generic/SignatureComponent";

export function RiUserTrainingSignPage(props) {
  const classes = useRiUserTrainingSignPageStyles();
  const { userId, webUserId, documentName } = useParams();

  return (
    <PageWithAppDrawer2 pageTitle={"NHTSA RI Training"}>
      <Paper className={classes.paper}>
        <Typography variant="h6">Acknowledge review of 2024 DVS RI User Run Book</Typography>
        <SignatureComponent
          userId={userId}
          saveUrl={`api/training/${webUserId}/sign/${documentName}?userId=${userId}`}
        />
      </Paper>
    </PageWithAppDrawer2>
  );
}

const useRiUserTrainingSignPageStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));

export { RiUserTrainingSignPage as default };
